import { render, staticRenderFns } from "./mon.vue?vue&type=template&id=52e84adb&scoped=true&"
import script from "./mon.vue?vue&type=script&lang=js&"
export * from "./mon.vue?vue&type=script&lang=js&"
import style0 from "./mon.vue?vue&type=style&index=0&id=52e84adb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e84adb",
  null
  
)

export default component.exports